// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"08fd81b4c91147edb4da","883":"90694bb91191416a08f3"}[chunkId] + ".js";
};